import PropTypes from 'prop-types'
import { MaskedInput } from 'baseui/input'
import { mergeOverrides } from 'baseui'
import { SMaskedInputOverrides } from './styled-components'
import { Alert, Delete } from 'baseui/icon'
import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'
import InfoIcon from '../icon_info.svg'
import { useEffect, useState } from 'react'
import { RelativeContainer, FloatingLabel } from '@/shared/theme/styled-components'

const SDMaskedInput = ({ label, overrides, status, currentValue, onBlur, error, ...rest }) => {
  const [value, setValue] = useState(currentValue || null)

  const iconMapping = {
    valid: <IconCarbonCheckmarkOutline size={24} color='green' />,
    info: <img src={InfoIcon} alt='Info' style={{ width: 24, height: 24 }} />,
    warning: <Alert size={24} color='orange' />,
    error: <Delete size={24} color='red' />,
  }

  const endEnhancer =
    status && iconMapping[status] ? () => <div className='sdinput-end-enhancer'>{iconMapping[status]}</div> : null

  const newOverrides = mergeOverrides(SMaskedInputOverrides(error || false), overrides)

  useEffect(() => {
    if (currentValue === null || currentValue === undefined) {
      setValue('')
      return
    }
    setValue(currentValue)
  }, [currentValue])

  return (
    <RelativeContainer>
      {label && (
        <FloatingLabel>
          <div dangerouslySetInnerHTML={{ __html: label }} />
        </FloatingLabel>
      )}
      <MaskedInput
        {...rest}
        error={error}
        overrides={newOverrides}
        onBlur={e => {
          if (typeof onBlur === 'function') {
            let selectedValue = e.target.value
            if (selectedValue === '') {
              selectedValue = null
            }
            onBlur(selectedValue)
          }
        }}
        onChange={e => setValue(e.target.value)}
        endEnhancer={endEnhancer ?? rest.endEnhancer ?? null}
        value={value}
      />
    </RelativeContainer>
  )
}

SDMaskedInput.propTypes = {
  label: PropTypes.node,
  overrides: PropTypes.object,
  status: PropTypes.oneOf(['valid', 'info', 'warning', 'error']),
  currentValue: PropTypes.any,
  onBlur: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default SDMaskedInput
